import { render, staticRenderFns } from "./ParameterExtractorConfiguration.vue?vue&type=template&id=08ae0c4e&"
import script from "./ParameterExtractorConfiguration.vue?vue&type=script&lang=ts&"
export * from "./ParameterExtractorConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports